import { FC } from 'react';
import {
  Box,
  HStack,
  Icon,
  NavigationButton,
  Text,
  VStack,
} from '@wegroup/design-system';
import { FlowProductsSidebarItem } from '@flows/src/components/flow-products/FlowProductsSidebar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useFlowProductsOverviewParams } from '@flows/src/hooks/flow-products/useFlowProductsOverviewParams';

interface Props {
  items: FlowProductsSidebarItem[];
}

const FlowProductsSideBarOverviewItems: FC<Props> = ({ items }) => {
  const { flowId, tagId } = useFlowProductsOverviewParams();
  const { t } = useTranslation();
  const history = useHistory();

  const handleNavigate = (_tagId: string) => {
    history.push({
      pathname: `${FLOWS_PRODUCTS_PATH}/${flowId}/overview/${_tagId}`,
      search: window.location.search,
    });
  };

  return (
    <>
      <Text textStyle="normalBodyMedium" w="xs" px="4">
        {t('FLOW_PRODUCTS_SIDEBAR_TITLE')}
      </Text>
      <VStack align="stretch" spacing="2" overflowY="auto" pb="4" px="4">
        {items.map((item) => {
          const { iconName, key } = item;
          const isActive = tagId === key;
          return (
            <NavigationButton
              key={key}
              onClick={() => handleNavigate(key)}
              size="md"
              isActive={isActive}
            >
              <HStack spacing="2">
                {iconName && (
                  <Box
                    color={isActive ? 'primary.500' : 'gray.500'}
                    transition="0.2s"
                  >
                    <Icon name={iconName} />
                  </Box>
                )}
                <Text>{item.label}</Text>
              </HStack>
            </NavigationButton>
          );
        })}
      </VStack>
    </>
  );
};

export default FlowProductsSideBarOverviewItems;
